import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pb-2" }
const _hoisted_2 = { class: "bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex justify-end items-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_7 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_8 = { class: "w-full xl:w-4/4" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "w-full xl:w-2/4 flex xl:justify-end justify-start" }
const _hoisted_11 = { class: "input-wrapper" }
const _hoisted_12 = { class: "flex mt-1" }
const _hoisted_13 = { class: "flex items-center cursor-pointer" }
const _hoisted_14 = { class: "flex flex-row gap-5" }
const _hoisted_15 = {
  key: 0,
  class: "xl:w-9/12"
}
const _hoisted_16 = { class: "w-full w-full flex" }
const _hoisted_17 = { class: "input-wrapper" }
const _hoisted_18 = { class: "flex mt-1" }
const _hoisted_19 = { class: "flex items-center cursor-pointer" }
const _hoisted_20 = {
  key: 1,
  class: "xl:w-9/12"
}
const _hoisted_21 = {
  key: 2,
  class: "xl:w-3/12"
}
const _hoisted_22 = { class: "input-wrapper" }
const _hoisted_23 = { class: "flex items-center cursor-pointer mt-1" }
const _hoisted_24 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "input-wrapper" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = {
  key: 0,
  class: "flex gap-3 xl:flex-row flex-col items-start mb-3"
}
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "flex justify-between items-center" }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["textContent"]
const _hoisted_33 = {
  key: 1,
  class: "bg-theme-borderblack h-1 w-full my-4"
}
const _hoisted_34 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_35 = { class: "w-full xl:w-3/4" }
const _hoisted_36 = { class: "block rounded bg-gray-black w-full text-sm px-1 py-[5px]" }
const _hoisted_37 = {
  for: "cp",
  class: "w-full flex"
}
const _hoisted_38 = ["textContent"]
const _hoisted_39 = { class: "w-full xl:w-3/4" }
const _hoisted_40 = ["textContent"]
const _hoisted_41 = { class: "w-full xl:w-3/4" }
const _hoisted_42 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_43 = { class: "w-full xl:w-3/4" }
const _hoisted_44 = { class: "input-wrapper" }
const _hoisted_45 = {
  for: "thc/cbd-togglestatus",
  class: "flex relative items-center cursor-pointer px-1 py-1"
}
const _hoisted_46 = { class: "flex items-center cursor-pointer" }
const _hoisted_47 = { class: "w-full xl:w-3/4" }
const _hoisted_48 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxSelectCheckbox = _resolveComponent("TaxSelectCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "font-semibold leading-tight truncate text-2xl mt-0" }, "New Category", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addNewCategory()), ["prevent"])),
              class: "cursor-pointer rounded-md bg-white text-theme-green py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3"
            }, " SAVE "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
              class: "cursor-pointer rounded-md text-white py-2 pl-1 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
          }, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name.value) = $event)),
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['name']))),
              placeholder: "E.g. Dried Flower",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.name.value]
            ]),
            (_ctx.form.name.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.name.error_message)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "mb-0 text-xs" }, "Category Type", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.isSubCategory = false)),
                class: _normalizeClass('cursor-pointer mr-2 text-sm font-medium ' + (_ctx.form.isSubCategory ? 'text-theme-878686' : 'text-white'))
              }, " Main ", 2),
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.isSubCategory) = $event)),
                  class: "hidden peer"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isSubCategory]
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("div", {
                  class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full bg-theme-green border-theme-green')
                }, null, -1))
              ]),
              _createElementVNode("span", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.isSubCategory = true)),
                class: _normalizeClass('cursor-pointer ml-2 text-sm font-medium ' + (_ctx.form.isSubCategory ? 'text-white' : 'text-theme-878686'))
              }, " Sub ", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.globalLotSetting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "mb-0 text-xs" }, "Lot Tracking", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.lotTracking = false)),
                      class: _normalizeClass('cursor-pointer mr-2 text-sm font-medium ' + (_ctx.form.lotTracking ? 'text-theme-878686' : 'text-white'))
                    }, " Off ", 2),
                    _createElementVNode("label", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.lotTracking) = $event)),
                        class: "hidden peer"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.lotTracking]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["relative toggle-bg border-2 h-6 w-11 rounded-full", _ctx.form.lotTracking?'bg-theme-green border-theme-green':'bg-theme-red border-theme-red'])
                      }, null, 2)
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.lotTracking = true)),
                      class: _normalizeClass('cursor-pointer ml-2 text-sm font-medium ' + (_ctx.form.lotTracking ? 'text-white' : 'text-theme-878686'))
                    }, " On ", 2)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20)),
        (_ctx.globalExemptScanner?.enableScannerVerification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-xs" }, "Exempt from Scanning", -1)),
                _createElementVNode("label", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.exemptFromScanning) = $event)),
                    class: "hidden peer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.exemptFromScanning]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["relative toggle-bg border-2 h-6 w-11 rounded-full", 
                        _ctx.form.exemptFromScanning
                          ? 'bg-theme-green border-theme-green'
                          : 'bg-theme-red border-theme-red'
                      ])
                  }, null, 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "bg-theme-borderblack h-1 w-full my-4" }, null, -1)),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { class: "text-xs mb-1" }, "Description", -1)),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.description) = $event)),
                placeholder: "Write a description for the category",
                class: "border-none block rounded bg-gray-black w-full text-sm"
              }, null, 512), [
                [_vModelText, _ctx.form.description]
              ])
            ])
          ])
        ])
      ]),
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "bg-theme-borderblack h-1 w-full my-4" }, null, -1)),
      (_ctx.form.isSubCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper ' + (_ctx.form.parent.error_type))
              }, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "text-xs mb-1" }, "Parent Category", -1)),
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("select", {
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateFields(['parent']))),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.parent.value) = $event)),
                    class: _normalizeClass('border-none block rounded bg-gray-black w-full text-sm '  + (_ctx.form.parent.value != null ? 'text-white' : 'text-theme-878686'))
                  }, [
                    _cache[31] || (_cache[31] = _createElementVNode("option", {
                      value: null,
                      disabled: ""
                    }, "-- Select --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingProductParentCategories, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: 'drop_cat'+ category.id,
                        value: category.id
                      }, _toDisplayString(category.name), 9, _hoisted_31))
                    }), 128))
                  ], 34), [
                    [
                      _vModelSelect,
                      _ctx.form.parent.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                (_ctx.form.parent.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.parent.error_message)
                    }, null, 8, _hoisted_32))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.form.isSubCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33))
        : _createCommentVNode("", true),
      _cache[44] || (_cache[44] = _createElementVNode("div", { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }, null, -1)),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.posColour.error_type))
          }, [
            _cache[33] || (_cache[33] = _createElementVNode("label", { class: "text-xs mb-1" }, "Color", -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  class: "w-6 bg-transparent",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validateFields(['posColour']))),
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.posColour.value) = $event)),
                  id: "cp",
                  type: "color"
                }, null, 544), [
                  [_vModelText, _ctx.form.posColour.value]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass('pl-2 items-center flex ' + (_ctx.form.posColour.value ? 'text-white': 'text-theme-878686'))
                }, _toDisplayString(_ctx.form.posColour.value ? _ctx.form.posColour.value : '-- Select --'), 3)
              ])
            ]),
            (_ctx.form.posColour.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.posColour.error_message)
                }, null, 8, _hoisted_38))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.ComplianceType.error_type))
          }, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "mb-0 text-xs" }, "Compliance Type", -1)),
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validateFields(['ComplianceType']))),
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.ComplianceType.value) = $event)),
              class: _normalizeClass('block rounded bg-gray-black border-none w-full text-sm ' + (_ctx.form.ComplianceType.value ? 'text-white' : 'text-theme-878686'))
            }, [...(_cache[34] || (_cache[34] = [
              _createStaticVNode("<option value=\"\" disabled>--Select--</option><option value=\"Dried flower\">Dried flower</option><option value=\"Pre rolled\">Pre rolled</option><option value=\"Extracts ingested\">Extracts ingested</option><option value=\"Extracts inhaled\">Extracts inhaled</option><option value=\"Edibles solids\">Edibles solids</option><option value=\"Edibles non-solids\">Edibles non-solids</option><option value=\"Topicals\">Topicals</option><option value=\"Accessory\">Accessory</option>", 9)
            ]))], 34), [
              [_vModelSelect, _ctx.form.ComplianceType.value]
            ]),
            (_ctx.form.ComplianceType.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.ComplianceType.error_message)
                }, null, 8, _hoisted_40))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-xs" }, "Tax", -1)),
          _createVNode(_component_TaxSelectCheckbox, {
            modelValue: _ctx.categoryTaxes,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.categoryTaxes) = $event)),
            options: _ctx.taxes,
            placeholder: "Select",
            class: _normalizeClass(["mt-2 block rounded bg-gray-black w-full border-none text-sm tracking-wider", _ctx.categoryTaxes.length>0?'text-white':'text-theme-878686'])
          }, null, 8, ["modelValue", "options", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "mb-0 text-xs" }, "THC/CBD Values", -1)),
            _createElementVNode("label", _hoisted_45, [
              _cache[38] || (_cache[38] = _createElementVNode("input", {
                type: "checkbox",
                value: "range",
                id: "thc/cbd-togglestatus",
                class: "hidden peer"
              }, null, -1)),
              _createElementVNode("span", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.thcCbdValueTypeRange = false)),
                class: _normalizeClass('mr-2 text-sm font-medium ' + (_ctx.thcCbdValueTypeRange ? 'text-theme-878686' : 'text-white'))
              }, " Single ", 2),
              _createElementVNode("label", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.thcCbdValueTypeRange) = $event)),
                  class: "hidden peer"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.thcCbdValueTypeRange]
                ]),
                _cache[37] || (_cache[37] = _createElementVNode("div", {
                  class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full bg-theme-green border-theme-green')
                }, null, -1))
              ]),
              _createElementVNode("span", {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.thcCbdValueTypeRange = true)),
                class: _normalizeClass('ml-2 text-sm font-medium ' + (_ctx.thcCbdValueTypeRange ? 'text-white' : 'text-theme-878686'))
              }, " Range ", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.concentrationUnit.error_type))
          }, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "mb-0 text-xs" }, "THC/CBD Unit", -1)),
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateFields(['concentrationUnit']))),
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.concentrationUnit.value) = $event)),
              class: _normalizeClass('block rounded bg-gray-black border-none w-full text-sm ' + (_ctx.form.concentrationUnit.value ? 'text-white' : 'text-theme-878686'))
            }, [...(_cache[40] || (_cache[40] = [
              _createStaticVNode("<option value=\"\" disabled>--Select--</option><option value=\"%\">%</option><option value=\"mg/g\">Mg/g</option><option value=\"mg/ml\">Mg/Ml</option><option value=\"mg\">Mg</option><option value=\"ml\">Ml</option><option value=\"mg/bottle\">Mg/bottle</option><option value=\"mg/pack\">Mg/pack</option><option value=\"mg/unit\">Mg/unit</option>", 9)
            ]))], 34), [
              [_vModelSelect, _ctx.form.concentrationUnit.value]
            ]),
            (_ctx.form.concentrationUnit.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.concentrationUnit.error_message)
                }, null, 8, _hoisted_48))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
}